export const dateTimeZone = (date1) => {
    const d = (new Date()).getTimezoneOffset() * 60000;
    return (new Date(date1 - d)).toISOString().substring(0, 10);
}